export default __webpack_public_path__ + "static/media/shieldsweep4.4281405a.png";